import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

// Import translations
import deTranslation from './locales/de.json';
import enTranslation from './locales/en.json';

const resources = {
  de: {
    translation: deTranslation
  },
  en: {
    translation: enTranslation
  }
};

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources,
    fallbackLng: 'de', // Deutsch als Fallback-Sprache
    lng: 'de', // Deutsch als Standard-Sprache
    debug: import.meta.env.DEV, // Debug nur im Development

    interpolation: {
      escapeValue: false // React escapes by default
    },

    detection: {
      order: ['localStorage', 'navigator', 'htmlTag'],
      caches: ['localStorage']
    }
  });

export default i18n;
